<template>
  <b-card class="border mb-0" no-body>
    <b-card-body
      class="d-flex align-items-center p-1"
      :class="center ? 'justify-content-center text-center' : ''"
    >
      <div
        :style="{
          flex: center ? '0 1 auto' : '1 1 0%',
          minWidth: 0,
          overflow: 'hidden'
        }"
      >
        <h2
          class="mb-25 font-weight-bolder"
          :style="{
            display: 'block',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }"
        >
          {{ value }}
        </h2>

        <div
          :style="{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }"
        >
          <span>{{ text }}</span>
          <template v-if="shortText">
            (<short-text :text="shortText" />)
          </template>
        </div>
      </div>

      <b-avatar
        v-if="!center"
        :variant="['light', variant].join('-')"
        size="45"
        :style="{ flex: '0 0 auto' }"
      >
        <span class="material-icons-outlined">{{ icon }}</span>
      </b-avatar>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BAvatar,BCardBody } from "bootstrap-vue";
import ShortText from "@/components/ShortText";
export default {
    components:{
        BCard,
        BAvatar,
        BCardBody,
        ShortText
    },
    props:{
        value:[String,Number],
        text:String,
        icon:String,
        shortText:String,
        variant:{
            type:String,
            default:"primary"
        },
        center:{
            type:Boolean,
            default:false
        }
    },
}
</script>